import '../styles.css';
import { mountLibrary } from './page.js';

mountLibrary();
